import React, { useState, useEffect } from "react";
import Form from 'olive-react-myoneui/lib/Form';
import FloatingLabel from 'olive-react-myoneui/lib/FloatingLabel';
import Button from 'olive-react-myoneui/lib/Button';
import CircleImage from "olive-react-myoneui/lib/CircleImage";
import { chatIcon, chatFilledIcon, heartIcon, heartFilledIcon } from "../../../constants/icons";
import LinkWrapper from "../../LinkWrapper";
import CommentBlock from "./CommentBlock";
import { pluralize, numberToShortForm } from "../../../../helpers/string_helper";
import { Global, getComments } from "../../../../api/afterLogin/newsFeed";

const CommentsLikesBlock = ({ className, userProfle, postLikedByUser, postComments, postTotalComments, postTotalLikes, postId, newsFeedLunchUrl, newsFeedApiUrl, postedComment }) => {
    const [liked, setLiked] = useState(false);
    const [commentText, setCommentText] = useState('');
    const [showComments, setShowComments] = useState(false);
    const [comments, setComments] = useState(postComments);
    const [commentsMeta, setCommentsMeta] = useState([]);
    const [remainComments, setRemainComments] = useState(postTotalComments);
    const [totalComments, setTotalComments] = useState(postTotalComments);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickLike = (paramPostId) => {
        const socket = Global.getSocket();
        try {
            let obj = {
              newsFeedClientId: paramPostId,
              urlParams: newsFeedLunchUrl,
            };
            // Set Working in Progress
            if (socket) {
                socket.emit('like', obj);
            }
      
          } catch (error) {
            console.log(error);
          }
        setLiked(prevLiked => !prevLiked);
    };

    const handleCommentChange = (e) => {
        setCommentText(e.target.value);
    };

    const handleShowComments = async (id) => {
        if (postTotalComments) {
            const params = {
                id: id,
                newsFeedApiUrl: newsFeedApiUrl,
                newsFeedLunchUrl: newsFeedLunchUrl
            }
            try {
                const response = await getComments(params);
                if (response) {
                    let remainComments = response.meta.total - response.meta.currentPage * response.meta.perPage;
                    setComments(response);
                    setTotalComments(response.data.length);
                    setCommentsMeta(response.meta);
                    setRemainComments(remainComments);
                }
            } catch (error) {
                console.log(error);
            }
        }
        setShowComments(prevCommented => !prevCommented)
    };

    const postComment = async (paramPostId) => {
        const socket = Global.getSocket();
        setIsLoading(true);
        if (paramPostId) {
            const obj = {
              newsFeedClientId: paramPostId,
              commentDescription: commentText.trim(),
              urlParams: newsFeedLunchUrl,
            };
            if (commentText.trim().length == 0) {
              alert('Comment Message is empty');
            } else {
              setCommentText('');
              if (socket) {
                socket.emit('comment', obj);
                const params = {
                    id: paramPostId,
                    newsFeedApiUrl: newsFeedApiUrl,
                    newsFeedLunchUrl: newsFeedLunchUrl
                }
                const response = await getComments(params);
                if (response) {
                    setComments(response);
                }
              }
            }
        }
    }

    const loadMoreComments = async (postId) => {
        try {
            let meta = Object.assign({}, commentsMeta);
            meta.currentPage += 1;
            let remainComments = meta.total - meta.currentPage * meta.perPage;
      
            let payload = {
                id: postId,
                currentPage: meta.currentPage,
                newsFeedApiUrl: newsFeedApiUrl,
                newsFeedLunchUrl: newsFeedLunchUrl
            };
            const response = await getComments(payload)
            if (response) {
                let prevComments = [...comments.data];
      
                let i = 0;
                while (i < response.data.length) {
                    prevComments.push(response.data[i]);
                  i++;
                }
                let data = {
                    data:prevComments,
                    message:"success",
                    meta:response.meta
                }
                setComments(data)
                setCommentsMeta(response.meta);
                setRemainComments(remainComments < 0 ? 0 : remainComments)
            }
              
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        setComments(postComments)
    },[postComments])

    return (
        <>
        <div className={`${className || ""}`}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-3">
                    <div className={`btn-reponse d-flex align-items-center justify-content-center gap-1 ${liked ? 'liked' : ''}`} onClick={() => handleClickLike(postId)}>
                        <div className="icon">{postLikedByUser ? heartFilledIcon : heartIcon}</div>
                        <span className="flex-1">Like</span>
                    </div>
                    <div className={`btn-reponse d-flex align-items-center gap-1 ${showComments ? 'shown-comments' : ''}`} onClick={() => handleShowComments(postId)}>
                        <div className="icon">{totalComments && totalComments > 0 ? chatFilledIcon : chatIcon}</div>
                        <span>Comment</span>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <span className="count-like">{numberToShortForm(postTotalLikes)} {pluralize(postTotalLikes,'Like')}</span>
                    <span className="count-comment">{numberToShortForm(postTotalComments)} {pluralize(postTotalComments,'Comment')}</span>
                </div>
            </div>
        </div>
        {showComments && (
          <div className="myk__stu-comments-wrapper">
            <div className="myk__stu-comments-counter d-flex align-items-center justify-content-between">
                {remainComments === 0 ?
                (<LinkWrapper></LinkWrapper>) :
                (<LinkWrapper onClick={(e)=>{e.preventDefault(); loadMoreComments(postId)}}>Load more comments</LinkWrapper>)
                }
                <div className="myk__stu-viewable-comments">{comments && comments?.data ? comments?.data.length : 0} of {postTotalComments ?? 0}</div>
            </div>
            <div className="myk__stu-comment-block information-block bg-information-white pt-4 p-0 mb-0">
                {comments && comments?.data?.map((comment, index) => (
                    <CommentBlock 
                        key={index}
                        userProfle={userProfle}
                        commentId={comment?._id}
                        commentImage={comment?.creator?.profilePic} 
                        commentName={comment?.creator?.name}  
                        comment={comment?.commentDescription}
                        numberOfLikes={comment?.totalLikes}
                        numberOfReplies={comment?.totalReplies}
                        createdAt={comment?.createdAt}
                        likedByUser={comment?.likedByUser}
                        newsFeedApiUrl={newsFeedApiUrl}
                        newsFeedLunchUrl={newsFeedLunchUrl}
                        newsFeedClientId={comment?.newsFeedClient}
                        postTotalComments={postTotalComments}
                    />
                ))}
            </div>
            <div className="myk__stu-comment-field">
                <div className="information-wrap mb-0">
                    <div className="information-holder align-items-start">
                        <CircleImage className="circle-wrap circle-wrap-sm">
                            {userProfle && (<img src={userProfle} alt="Profile" />)}
                        </CircleImage>
                        <div className="information-detail">
                            <FloatingLabel className="w-100" controlId="floatingTextarea2" label="Join the conversation">
                                <Form.Control
                                    as="textarea"
                                    placeholder="Join the conversation"
                                    style={{ height: '72px' }}
                                    value={commentText}
                                    onChange={handleCommentChange}
                                />
                            </FloatingLabel>
                            <Button 
                                variant="primary" 
                                className="mt-2 btn-round text-white btn-sm px-4" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    postComment(postId)
                                }}
                            >
                                Post Comment
                            </Button>
                        </div>
                    </div>
                </div>
            </div> 
          </div>
        )}
        </>
    );
};

export default CommentsLikesBlock;
